<!--
  author：wangjp
  description：试题信息管理
  date：2024年1月15日13:57:35
-->
<template>
  <el-container>
    <el-drawer title="试题信息管理" :visible="formVisible" :before-close="handleClose" append-to-body :wrapperClosable="false"
               @open="handleOpen">
      <div style="height: calc(100% - 67px);">
        <el-scrollbar class="drawer_scrollbar">
          <el-row style="padding: 30px">
            <el-form ref="form" :model="form" :rules="rules" label-width="90px">
              <el-form-item label="所属课程" prop="lessonId">
                <el-select value-key="id" v-model="form.lessonId" placeholder="请选择所属课程" style="width: 100%" size="medium">
                  <el-option v-for="item in lessonData" :key="item.id" :label="item.lessonName"
                             :value="item.id"/>
                </el-select>
              </el-form-item>
              <el-form-item label="试题类型" prop="questionType">
                <el-select value-key="value" v-model="form.questionType" @change="questionTypeChange" placeholder="请选择试题类型" style="width: 100%" size="medium">
                  <el-option v-for="dict in questionTypeData" :key="dict.value" :label="dict.name" :value="dict.value"/>
                </el-select>
              </el-form-item>
              <el-form-item label="试题描述" prop="questionDetail">
                <el-input type="textarea" rows="3" v-model="form.questionDetail" placeholder="请输入试题描述"/>
              </el-form-item>
              <el-form-item label="正确答案" prop="realAnswerArr">
                <el-select value-key="value" v-model="form.realAnswerArr" :multiple="realAnswerMultiple" placeholder="请选择正确答案" style="width: 100%" size="medium">
                  <el-option v-for="option in realAnswerData" :key="option.value" :label="option.text" :value="option.value"/>
                </el-select>
              </el-form-item>
              <el-form-item label="选项A" prop="optionAa" v-if="formState === 'select' || formState === 'multiSelect'">
                <el-input v-model="form.optionAa" placeholder="请输入选项A" size="medium"/>
              </el-form-item>
              <el-form-item label="选项B" prop="optionBb" v-if="formState === 'select' || formState === 'multiSelect'">
                <el-input v-model="form.optionBb" placeholder="请输入选项B" size="medium"/>
              </el-form-item>
              <el-form-item label="选项C" prop="optionCc" v-if="formState === 'select' || formState === 'multiSelect'">
                <el-input v-model="form.optionCc" placeholder="请输入选项C" size="medium"/>
              </el-form-item>
              <el-form-item label="选项D" prop="optionDd" v-if="formState === 'select' || formState === 'multiSelect'">
                <el-input v-model="form.optionDd" placeholder="请输入选项D" size="medium"/>
              </el-form-item>
              <el-form-item label="选项E" prop="optionEe" v-if="formState === 'multiSelect'">
                <el-input v-model="form.optionEe" placeholder="请输入选项E" size="medium"/>
              </el-form-item>
              <el-form-item label="选项F" prop="optionFf" v-if="formState === 'multiSelect'">
                <el-input v-model="form.optionFf" placeholder="请输入选项F" size="medium"/>
              </el-form-item>
              <el-form-item label="选项G" prop="optionGg" v-if="formState === 'multiSelect'">
                <el-input v-model="form.optionGg" placeholder="请输入选项G" size="medium"/>
              </el-form-item>
            </el-form>
          </el-row>
        </el-scrollbar>
      </div>
      <el-row class="drawer_footer">
        <el-button type="primary" @click="submit" :disabled="$store.state.loading" size="medium">确 定</el-button>
        <el-button @click="handleClose" :disabled="$store.state.loading" size="medium">取 消</el-button>
      </el-row>
    </el-drawer>
  </el-container>
</template>

<script>

  export default {
    name: "ExamQuestionForm",
    props: ['formVisible', 'selRow', 'submitUrl','questionTypeData', 'lessonData'],
    data() {
      const optionFfValid = async (rule, value, callback) => {
        if (value && !this.form.optionEe) {
          return callback(new Error('选项F不为空，选项E也不能为空'));
        }else {
          return callback()
        }
      };
      const optionGgValid = async (rule, value, callback) => {
        if (value && (!this.form.optionEe || !this.form.optionFf)) {
          return callback(new Error('选项G不为空，选项E和选项F都不能为空'));
        }else {
          return callback()
        }
      };
      return {
        form: {},
        rules: {
          lessonId: [
            {required: true, message: '请选择所属课程', trigger: 'blur'}
          ],
          questionType: [
            {required: true, message: '请选择试题类型', trigger: 'change'}
          ],
          questionDetail: [
            {required: true, message: '试题描述不能为空', trigger: 'blur'}
          ],
          realAnswerArr: [
            {required: true, message: '请选择正确答案', trigger: 'change'}
          ],
          optionAa: [
            {required: true, message: '选项A不能为空', trigger: 'blur'}
          ],
          optionBb: [
            {required: true, message: '选项B不能为空', trigger: 'blur'}
          ],
          optionCc: [
            {required: true, message: '选项C不能为空', trigger: 'blur'}
          ],
          optionDd: [
            {required: true, message: '选项D不能为空', trigger: 'blur'}
          ],
          optionFf: [
            {validator: optionFfValid, trigger: 'blur'}
          ],
          optionGg: [
            {validator: optionGgValid, trigger: 'blur'}
          ]
        },
        realAnswerData: [],
        questionTypeOptionSelect: [{value: 'A', text: 'A'}, {value: 'B', text: 'B'}, {value: 'C', text: 'C'}, {value: 'D', text: 'D'}],
        questionTypeOptionMultiSelect: [{value: 'A', text: 'A'}, {value: 'B', text: 'B'}, {value: 'C', text: 'C'}, {value: 'D', text: 'D'}, {value: 'E', text: 'E'}, {value: 'F', text: 'F'}, {value: 'G', text: 'G'}],
        questionTypeOptionDecide: [{value: '1', text: '正确'}, {value: '0', text: '错误'}],
        formState: '',
        realAnswerMultiple: false,
        value:{},
      }
    }
    ,methods:{
      async submit() {
        let valid = await this.$refs.form.validate().catch(() => {});
        if (!valid) return;
        let param = this.form;
        this.form.deptList = [];
        await this.postRequest(this.submitUrl, param);
        this.handleClose();
        this.$emit('refreshList')
      },
      handleOpen() {
        this.questTypeChangeHandle(this.selRow.questionType);
        this.$nextTick(() => { //表单dom操作和表单赋值同时进行会有问题，通过$nextTick让表单dom异步变化都完事后，再进行表单赋值，就没有异常了
          this.form = {...this.selRow};
          this.realAnswerArrConvert();
        })
      },
      questionTypeChange(selOption) {
        this.clearOption();
        this.questTypeChangeHandle(selOption);
      },
      clearOption() {
        this.form = {
          lessonId: this.form.lessonId,
          questionType: this.form.questionType,
          questionDetail: this.form.questionDetail,
          realAnswerArr: this.realAnswerMultiple ? [] : "", //下拉选组件单多选的状态对应的值为字符串数组或字符串
          optionAa: "",
          optionBb: "",
          optionCc: "",
          optionDd: "",
          optionEe: "",
          optionFf: "",
          optionGg: ""
        }
      },
      questTypeChangeHandle(selOption) {
        if ("1" === selOption) {
          this.realAnswerData = this.questionTypeOptionSelect;
          this.formState = "select";
          this.realAnswerMultiple = false;
        }
        if ("2" === selOption ) {

          this.realAnswerData = this.questionTypeOptionMultiSelect;
          this.formState = "multiSelect";
          this.$nextTick(() => { //单选切多选时会遇到选中项不清空的问题，通过$nextTick让dom异步变化都完事后，再切换单多选状态，就可以了
            this.realAnswerMultiple = true;
            this.form.realAnswerArr=[];
          })
        }
        if ("3" === selOption) {
          this.realAnswerData = this.questionTypeOptionDecide;
          this.formState = "decide";
          this.realAnswerMultiple = false;
        }
      },
      //正确答案值的格式转换，单选用字符串，多选用字符串数组
      realAnswerArrConvert() {
        if(!this.realAnswerMultiple) {
          this.form.realAnswerArr = this.form.realAnswer;
        }
      },
      handleClose() {
        this.$refs.form.clearValidate();
        this.$emit('update:formVisible', false)
      }
    }
  }
</script>

<style scoped>

</style>
